module.exports = __webpack_public_path__ + "img/news_3.be1222f7.jpg";